import { useEffect } from 'react';

export default function useClickOutside({
  refs,
  unless = false,
  onClick,
}) {
  useEffect(() => {
    const refsAsArray = Array.isArray(refs) ? refs : [refs];
    function handleOutsideClick(e) {
      const allRefsHaveCurrent = refsAsArray.every((ref) => !!ref.current);
      const shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;

      if (!allRefsHaveCurrent || shouldNotExecute) {
        return;
      }

      const isOutsideClick = refsAsArray.every((ref) => !ref.current.contains(e.target));

      if (isOutsideClick) {
        onClick(e);
      }
    }

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [unless, onClick, refs]);
}
